import useExecuteFirstTimeConditionIsMet from 'src/public/useExecuteFirstTimeConditionIsMet/useExecuteFirstTimeConditionIsMet';

/**
 * Use this hook to execute synchonous logic during the first render of a component
 * @param callback The callback to be run during the first render
 */
const useDuringFirstRender = (callback: () => void): void => {
  useExecuteFirstTimeConditionIsMet(
    true, // we always want to run the callback the first time this hook is called
    callback,
  );
};

export default useDuringFirstRender;
